const MIN_RETURNING_CONTOUR_NOTES = 6;
const MIN_RETURNING_CONTOUR_RANGE = 20;
const MIN_DIRECTION_CHANGE = 2;

/**
 * Long accompaniment figures that travel substantially in both vertical
 * directions are clearer with a level beam. Short or one-directional figures
 * retain VexFlow's normal angled-beam engraving.
 */
export const shouldFlattenReturningContourBeam = (positions: number[]): boolean => {
  if (
    positions.length < MIN_RETURNING_CONTOUR_NOTES ||
    positions.some((position) => !Number.isFinite(position))
  ) {
    return false;
  }

  const range = Math.max(...positions) - Math.min(...positions);
  if (range < MIN_RETURNING_CONTOUR_RANGE) return false;

  const deltas = positions.slice(1).map((position, index) => position - positions[index]);

  return (
    deltas.some((delta) => delta > MIN_DIRECTION_CHANGE) &&
    deltas.some((delta) => delta < -MIN_DIRECTION_CHANGE)
  );
};
